module.exports = __webpack_public_path__ + "media/images/loading_icon-51f08d72a27b4b4ab12acedcdfae3fc5.svg";